/**
 * 回傳 Console 網站網域
 * @param locale: 語系, ENVIRONMENT: 目前的ENV, includeHttps: 是否包含 "https:"
 * @returns String
 */

const provideConsoleDomain = (
  locale: EnumLocale,
  ENVIRONMENT: string,
  includeHttps = true
): string => {
  const https = includeHttps ? 'https:' : '';
  if (locale === EnumLocale.ZH_CN) {
    switch (ENVIRONMENT) {
      case 'PRODUCTION':
        return `${https}//console.wise.advantech.com.cn`;
      case 'STAGING':
        return `${https}//staging-console.wise.advantech.com.cn`;
      default:
        return `${https}//dev-console.wise.advantech.com.cn`;
    }
  } else {
    switch (ENVIRONMENT) {
      case 'PRODUCTION':
        return `${https}//console.wise.advantech.com`;
      case 'STAGING':
        return `${https}//staging-console.wise.advantech.com`;
      default:
        return `${https}//dev-console.wise.advantech.com`;
    }
  }
};

export default provideConsoleDomain;
